import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { BUSINESS, NAV_LINKS, SERVICES } from "@/data/site";

const Footer = () => (
  <footer className="bg-ink border-t border-steel" data-testid="site-footer">
    <div className="container-site py-16 lg:py-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <Link to="/" className="inline-flex" data-testid="footer-logo" aria-label="LAD CO Electrical home">
            <img src="/logo.png" alt="LAD CO Electrical — Level 2 Accredited Service Provider, Northern Rivers NSW" className="h-20 w-auto" />
          </Link>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-volt-bright mt-6">{BUSINESS.tagline}</p>
          <p className="text-gray-400 text-sm mt-4 leading-relaxed">
            A local family business and Level 2 accredited service provider with 20+ years of experience, servicing the Northern Rivers region of NSW.
          </p>
          <p className="mt-5 inline-flex items-center gap-2.5 border border-volt/40 bg-volt/10 px-3 py-2" data-testid="footer-emergency">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full bg-volt-bright opacity-60" />
              <span className="relative inline-flex h-2 w-2 bg-volt-bright" />
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-volt-bright">24/7 Emergency Service Available</span>
          </p>
          <div className="flex gap-3 mt-5">
            <a
              href="https://www.facebook.com/profile.php?id=61593414962448"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LAD CO Electrical on Facebook"
              data-testid="footer-facebook"
              className="w-10 h-10 border border-steel flex items-center justify-center text-gray-400 transition-colors duration-200 hover:text-volt-bright hover:border-volt"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a
              href="https://www.instagram.com/ladcoelectrical/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LAD CO Electrical on Instagram"
              data-testid="footer-instagram"
              className="w-10 h-10 border border-steel flex items-center justify-center text-gray-400 transition-colors duration-200 hover:text-volt-bright hover:border-volt"
            >
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h3 className="font-heading text-white font-bold uppercase tracking-wider text-sm mb-5">Pages</h3>
          <ul className="space-y-3">
            {[...NAV_LINKS, { label: "Request a Quote", to: "/quote" }].map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-gray-400 text-sm hover:text-volt-bright transition-colors duration-200">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-white font-bold uppercase tracking-wider text-sm mb-5">Services</h3>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link to="/services" className="text-gray-400 text-sm hover:text-volt-bright transition-colors duration-200">
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-white font-bold uppercase tracking-wider text-sm mb-5">Contact</h3>
          <ul className="space-y-4 text-sm">
            <li>
              <a href={BUSINESS.phoneHref} className="flex items-center gap-3 text-gray-400 hover:text-volt-bright transition-colors duration-200" data-testid="footer-phone">
                <Phone className="w-4 h-4 text-volt-bright shrink-0" /> {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a href={BUSINESS.emailHref} className="flex items-center gap-3 text-gray-400 hover:text-volt-bright transition-colors duration-200 break-all" data-testid="footer-email">
                <Mail className="w-4 h-4 text-volt-bright shrink-0" /> {BUSINESS.email}
              </a>
            </li>
            <li className="flex items-center gap-3 text-gray-400">
              <MapPin className="w-4 h-4 text-volt-bright shrink-0" /> {BUSINESS.region}
            </li>
          </ul>
          <Link to="/contact" className="btn-volt mt-6 !px-5 !py-3 !text-xs" data-testid="footer-contact-button">
            Contact Us
          </Link>
        </div>
      </div>
    </div>
    <div className="border-t border-steel">
      <div className="container-site py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-gray-500 text-xs" data-testid="footer-copyright">© 2026 LAD CO Electrical. All Rights Reserved.</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-volt-bright">Level 2 Accredited Service Provider</p>
      </div>
    </div>
  </footer>
);

export default Footer;
